import PropTypes from 'prop-types';
import React from 'react';

const SpecificationLine = ({ description }) => {
    return (
        !!description && (
            <p className="listing-tile-package sr-disclaimer">
                <icon className="icon-Crochet" />
                <span className="listing-tile-package-description">{description}</span>
            </p>
        )
    );
};

SpecificationLine.defaultProps = {
    description: '',
};

SpecificationLine.propTypes = {
    description: PropTypes.string,
};

SpecificationLine.displayName = 'NewTile.SpecificationLine';

export default SpecificationLine;
